(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lasgym-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lasgym-mega-nav')) {
    customElements.define('lasgym-mega-nav', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.menus = [...this.querySelectorAll('.LgMenu')];
        this.desktop = window.matchMedia('(min-width: 1008px)');
        this.hover = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.header = this.closest('site-header');
        this.setTop = () => {
          if (!this.header) return;
          this.style.setProperty('--lg-menu-top', Math.max(0, this.header.getBoundingClientRect().bottom) + 'px');
        };
        this.setTop();
        this.observer = new ResizeObserver(this.setTop);
        if (this.header) this.observer.observe(this.header);
        window.addEventListener('scroll', this.setTop, { passive: true, signal: this.controller.signal });
        window.addEventListener('resize', () => {
          this.setTop();
          if (!this.desktop.matches) this.closeAll();
        }, options);
        for (const menu of this.menus) {
          const summary = menu.querySelector('summary');
          menu.addEventListener('toggle', () => {
            summary.setAttribute('aria-expanded', String(menu.open));
            if (menu.open) {
              this.setTop();
              this.menus.forEach(other => { if (other !== menu) other.open = false; });
            }
          }, options);
          menu.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'mouse' || !this.hover.matches || !this.desktop.matches) return;
            clearTimeout(this.closeTimer);
            clearTimeout(this.openTimer);
            this.openTimer = setTimeout(() => {
              this.menus.forEach(other => { if (other !== menu) other.open = false; });
              this.setTop();
              menu.open = true;
            }, 100);
          }, options);
          menu.addEventListener('pointerleave', event => {
            if (event.pointerType !== 'mouse') return;
            clearTimeout(this.openTimer);
            this.closeTimer = setTimeout(() => {
              if (!menu.contains(document.activeElement)) menu.open = false;
            }, 200);
          }, options);
          summary.addEventListener('click', () => {
            clearTimeout(this.openTimer);
            clearTimeout(this.closeTimer);
          }, options);
          menu.querySelector('.LgMenu__Close').addEventListener('click', () => {
            menu.open = false;
            summary.focus();
          }, options);
          menu.addEventListener('keydown', event => {
            if (event.key === 'Escape' && menu.open) {
              event.preventDefault();
              event.stopPropagation();
              this.closeAll();
              summary.focus();
            }
            if (event.key === 'ArrowDown' && event.target === summary) {
              event.preventDefault();
              this.closeAll();
              menu.open = true;
              menu.querySelector('.LgMenu__Panel a')?.focus();
            }
          }, options);
          menu.addEventListener('focusout', event => {
            if (!menu.contains(event.relatedTarget)) menu.open = false;
          }, options);
        }
        this.querySelector('.LgMenu__Shade').addEventListener('click', () => this.closeAll(), options);
        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target)) this.closeAll();
        }, options);
      }
      closeAll() {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        this.menus.forEach(menu => { menu.open = false; });
      }
      disconnectedCallback() {
        this.closeAll();
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lasgym-mobile-menu-behavior"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lasgym-mobile-menu')) {
    customElements.define('lasgym-mobile-menu', class extends HTMLElement {
      connectedCallback() {
        this.drawer = this.querySelector('#MenuDrawer');
        this.header = document.getElementById('Header');
        this.trigger = document.getElementById('Header__MenuTrigger');
        if (!this.drawer || !this.header || !this.trigger) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.mobile = matchMedia('(max-width: 1007px)');
        this.updatePosition = () => {
          const top = Math.max(0, Math.round(this.header.getBoundingClientRect().bottom));
          this.style.setProperty('--lg-mobile-top', `${top}px`);
        };
        this.trigger.setAttribute('aria-controls', 'MenuDrawer');
        this.trigger.setAttribute('aria-expanded', 'false');
        this.drawer.addEventListener('show.tg.Drawer', () => {
          this.updatePosition();
          document.documentElement.classList.toggle('LgMobileMenuOpen', this.mobile.matches);
          this.trigger.setAttribute('aria-expanded', 'true');
        }, options);
        this.drawer.addEventListener('shown.tg.Drawer', () => {
          this.drawer.querySelector('.ButtonClose')?.focus({ preventScroll: true });
        }, options);
        this.drawer.addEventListener('hidden.tg.Drawer', () => {
          document.documentElement.classList.remove('LgMobileMenuOpen');
          this.trigger.setAttribute('aria-expanded', 'false');
        }, options);
        this.mobile.addEventListener('change', () => {
          if (!this.mobile.matches && this.drawer.classList.contains('Show')) {
            this.drawer.querySelector('[data-tg-dismiss="Drawer"]')?.click();
          }
          this.updatePosition();
        }, options);
        window.addEventListener('resize', this.updatePosition, options);
        window.visualViewport?.addEventListener('resize', this.updatePosition, options);
        this.observer = new ResizeObserver(this.updatePosition);
        this.observer.observe(this.header);
        this.updatePosition();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        document.documentElement.classList.remove('LgMobileMenuOpen');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lasgym-size-assistant"] && !Shopify.designMode) return;
  try {
    (() => {
  const bands = [[150,155,45,55,"XS"],[150,155,56,60,"S"],[150,155,61,65,"M"],[150,155,66,70,"L"],[150,155,71,75,"XL"],[156,160,56,60,"S"],[156,160,61,65,"M"],[156,160,66,70,"L"],[156,160,71,75,"XL"],[156,160,76,80,"2XL"],[161,165,61,65,"M"],[161,165,66,70,"L"],[161,165,71,75,"XL"],[161,165,76,80,"2XL"],[161,165,81,95,"3XL"],[166,170,66,70,"L"],[166,170,71,75,"XL"],[166,170,76,80,"2XL"],[166,170,81,95,"3XL"],[171,180,71,75,"XL"],[171,180,76,80,"2XL"],[171,180,81,100,"3XL"],[181,190,76,90,"2XL"],[181,190,91,100,"3XL"],[191,210,80,130,"3XL"]];
  const topsBands = [[150,155,45,55,"2XS"],[150,155,56,60,"XS"],[150,155,61,65,"S"],[150,155,66,70,"M"],[150,155,71,75,"L"],[156,160,56,60,"XS"],[156,160,61,65,"S"],[156,160,66,70,"M"],[156,160,71,75,"L"],[156,160,76,80,"XL"],[161,165,61,65,"S"],[161,165,66,70,"M"],[161,165,71,75,"L"],[161,165,76,80,"XL"],[161,165,81,95,"2XL"],[166,170,66,70,"M"],[166,170,71,75,"L"],[166,170,76,80,"XL"],[166,170,81,95,"2XL"],[171,180,71,75,"L"],[171,180,76,80,"XL"],[171,180,81,100,"2XL"],[181,190,76,90,"XL"],[181,190,91,100,"2XL"],[181,190,101,120,"3XL"],[191,200,80,120,"4XL"],[191,200,121,140,"5XL"]];
  const tankBands = [[150,155,45,55,"2XS"],[150,155,56,60,"XS"],[150,155,61,65,"S"],[150,155,66,70,"M"],[150,155,71,75,"L"],[156,160,56,60,"XS"],[156,160,61,65,"S"],[156,160,66,70,"M"],[156,160,71,75,"L"],[156,160,76,80,"XL"],[161,165,61,65,"S"],[161,165,66,70,"M"],[161,165,71,75,"L"],[161,165,76,80,"XL"],[161,165,81,95,"2XL"],[166,170,66,70,"M"],[166,170,71,75,"L"],[166,170,76,80,"XL"],[166,170,81,95,"2XL"],[171,180,71,75,"L"],[171,180,76,80,"XL"],[171,180,81,100,"2XL"],[181,190,76,90,"XL"],[181,190,91,100,"2XL"],[181,190,101,120,"3XL"],[191,200,80,120,"4XL"],[191,200,121,140,"5XL"]];
  const sizes = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];
  const normalize = value => ({XXS:'2XS', XXXS:'3XS', XXL:'2XL', XXXL:'3XL', XXXXL:'4XL', XXXXXL:'5XL'}[String(value).trim().toUpperCase()] || String(value).trim().toUpperCase());
  const number = value => /^\d+(?:[.,]\d+)?$/.test(value.trim()) ? Number(value.trim().replace(',', '.')) : NaN;
  const isOverFit = value => /\b(over|oversize|oversized|superover|superoversize)\b/.test(String(value || '').toLowerCase());
  const profile = (height, weight, family = '') => [...new Set((family === 'PROFILE_TANK_MEN' ? tankBands : ['PROFILE_TSHIRT_OVER','PROFILE_SWEATSHIRT'].includes(family) ? topsBands : bands).filter(([a,b,c,d]) => height >= a && height <= b && weight >= c && weight <= d).map(row => row[4]))];
  const rowsFor = family => ['BAGGY','SUPEROVER','OVER ELASTICO','VINTAGE'].includes(family) ? sizes.map((size, index) => ({size, waist:[30,33,34,36,38,40,42][index], length:(family === 'BAGGY' ? [99,100,102,104,106,108,110] : [97,99,101,103,105,107,109])[index]})) : [];
  const compare = (rows, waist, length) => {
    if (waist < rows[0].waist || waist > rows.at(-1).waist || length < rows[0].length || length > rows.at(-1).length) return {kind:'outside'};
    const near = (key, value) => {
      const distance = Math.min(...rows.map(row => Math.abs(row[key] - value)));
      return rows.filter(row => Math.abs(Math.abs(row[key] - value) - distance) < 1e-9).map(row => row.size);
    };
    const w = near('waist', waist), l = near('length', length), common = w.filter(size => l.includes(size));
    return common.length === 1 ? {kind:'match', size:common[0]} : {kind:'conflict', waist:w, length:l};
  };
  class LasgymSizeAssistant extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.texts = JSON.parse(this.querySelector('[data-size-texts]').textContent);
      this.trigger = this.querySelector('[data-open]');
      this.trigger.hidden = false;
      this.addEventListener('click', event => this.onClick(event), {signal:this.abort.signal});
      this.container = this.closest('section-product');
      this.syncEligibility();
      this.container?.addEventListener('variant:changed', event => {
        this.syncEligibility();
        if (!this.allowedFit()) return;
        if (this.pendingId && String(event.detail?.variant?.id) === this.pendingId) {
          clearTimeout(this.pendingTimer);
          this.pendingId = null;
          this.selectButton.disabled = false;
          this.querySelector('[data-announcement]').textContent = this.t('selected', this.resultSize);
          this.dialog.close();
        } else if (this.dialog?.open && this.panel === 'result' && !this.pendingId) {
          this.updateAvailability();
        }
      }, {signal:this.abort.signal});
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearTimeout(this.pendingTimer);
      this.initialized = false;
    }
    t(key, size = '') { return (this.texts[key] || '').replaceAll('[size]', size); }
    allowedFit() {
      if (this.dataset.family !== 'PROFILE_TSHIRT_OVER' || Number(this.dataset.fitIndex) < 0) return true;
      const option = this.container?.querySelectorAll('.Product__Block--variantPicker .ProductForm__Option')[Number(this.dataset.fitIndex)];
      return isOverFit((option?.querySelector('input:checked') || option?.querySelector('select'))?.value);
    }
    syncEligibility() {
      this.hidden = !this.allowedFit();
      if (this.hidden) {
        if (this.dialog?.open) this.dialog.close();
        clearTimeout(this.pendingTimer);
        this.pendingId = null;
        this.querySelector('[data-announcement]').textContent = '';
      }
    }
    find(selector) { return this.dialog.querySelector(selector); }
    open() {
      if (!this.allowedFit()) return;
      if (!this.dialog) {
        this.append(this.querySelector('[data-dialog-template]').content.cloneNode(true));
        this.dialog = this.querySelector('dialog');
        this.dialog.addEventListener('close', () => this.trigger.focus(), {signal:this.abort.signal});
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }, {signal:this.abort.signal});
        this.find('[data-profile-form]').addEventListener('submit', event => {event.preventDefault(); this.submitProfile();}, {signal:this.abort.signal});
        this.find('[data-measure-form]')?.addEventListener('submit', event => {event.preventDefault(); this.submitMeasures();}, {signal:this.abort.signal});
        this.find('[data-hem]')?.addEventListener('change', () => this.updateGuide(), {signal:this.abort.signal});
        this.selectButton = this.find('[data-select-size]');
      }
      this.querySelector('[data-announcement]').textContent = '';
      this.show('profile', false);
      this.dialog.showModal();
      this.find('[data-height]').focus();
    }
    onClick(event) {
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-open')) this.open();
      else if (button.hasAttribute('data-close')) this.dialog.close();
      else if (button.hasAttribute('data-back')) this.show(this.panel === 'result' || this.panel === 'message' ? this.origin || 'profile' : 'profile');
      else if ((button.hasAttribute('data-measures') || button.hasAttribute('data-message-measures')) && this.dataset.hasMeasures === 'true') {this.show('measures'); this.updateGuide();}
      else if (button.hasAttribute('data-select-size')) this.selectSize();
    }
    show(panel, focus = true) {
      this.panel = panel;
      this.dialog.querySelectorAll('[data-panel]').forEach(element => element.hidden = element.dataset.panel !== panel);
      this.find('[data-back]').hidden = panel === 'profile';
      this.dialog.scrollTop = 0;
      if (focus) (this.find(`[data-panel="${panel}"] h3`) || this.find('[data-height]'))?.focus();
    }
    error(selector, key) { const element = this.find(selector); element.textContent = this.t(key); element.hidden = false; }
    submitProfile() {
      if (!this.allowedFit()) return;
      this.find('[data-profile-error]').hidden = true;
      const height = number(this.find('[data-height]').value), weight = number(this.find('[data-weight]').value);
      if (!Number.isFinite(height) || !Number.isFinite(weight) || height <= 0 || weight <= 0) return this.error('[data-profile-error]', 'invalid');
      if (height < 3) return this.error('[data-profile-error]', 'cm_error');
      const candidates = profile(height, weight, this.dataset.family);
      this.origin = 'profile';
      if (candidates.length === 1) this.result(candidates[0], `${height} cm · ${weight} kg`, 'profile');
      else this.message(this.dataset.hasMeasures === 'true' ? 'uncovered_title' : 'uncovered_general_title', this.dataset.hasMeasures === 'true' ? 'uncovered' : 'uncovered_general');
    }
    family() { return this.dataset.family === 'CONDITIONAL' ? this.find('[data-hem]').value : this.dataset.family; }
    syncHem() {
      const select = this.find('[data-hem]');
      if (!select) return;
      const option = this.container?.querySelectorAll('.Product__Block--variantPicker .ProductForm__Option')[Number(this.dataset.hemIndex)];
      const value = (option?.querySelector('input:checked') || option?.querySelector('select'))?.value.trim().toLowerCase();
      const family = {'fondo con elastico caviglia':'OVER ELASTICO','fondo con elastico cavilgia':'OVER ELASTICO','con elastico':'OVER ELASTICO','fondo senza elastico':'SUPEROVER','senza elastico':'SUPEROVER'}[value];
      if (family) select.value = family;
      else if (select.dataset.auto === 'true') select.value = '';
      select.dataset.auto = String(Boolean(family));
      select.closest('label').hidden = Boolean(family);
    }
    updateGuide() {
      this.syncHem();
      const family = this.family();
      this.find('[data-guide]').hidden = !family;
      if (!family) return;
      this.find('[data-guide-family]').textContent = family;
      this.find('[data-guide-rows]').replaceChildren(...rowsFor(family).map(row => {
        const tr = document.createElement('tr');
        for (const value of [row.size, row.waist, row.length]) {const td = document.createElement('td'); td.textContent = value; tr.append(td);}
        return tr;
      }));
    }
    submitMeasures() {
      this.find('[data-measure-error]').hidden = true;
      const waist = number(this.find('[data-waist]').value), length = number(this.find('[data-length]').value), family = this.family();
      if (!family) return this.error('[data-measure-error]', 'hem_error');
      if (!Number.isFinite(waist) || !Number.isFinite(length) || waist <= 0 || length <= 0) return this.error('[data-measure-error]', 'invalid');
      this.origin = 'measures';
      const result = compare(rowsFor(family), waist, length);
      if (result.kind === 'match') this.result(result.size, `${family} · ${this.t('waist')}: ${waist} · ${this.t('length')}: ${length}`, 'measures');
      else if (result.kind === 'outside') this.message('outside_title', 'outside');
      else this.message('conflict_title', 'conflict', `${this.t('waist')}: ${result.waist.join(' / ')} · ${this.t('length')}: ${result.length.join(' / ')}`);
    }
    message(title, body, extra = '') {
      this.find('[data-message-title]').textContent = this.t(title);
      this.find('[data-message-body]').textContent = [extra, this.t(body)].filter(Boolean).join('. ');
      this.show('message');
    }
    result(size, summary, origin) {
      this.resultSize = size;
      this.origin = origin;
      this.find('[data-result-title]').textContent = this.t(origin === 'profile' ? 'recommended' : 'nearest');
      this.find('[data-result-size]').textContent = size;
      this.find('[data-result-summary]').textContent = summary;
      this.show('result');
      this.updateAvailability();
    }
    choice() {
      const option = this.container?.querySelectorAll('.Product__Block--variantPicker .ProductForm__Option')[Number(this.dataset.sizeIndex)];
      const control = option && [...option.querySelectorAll('input[type="radio"], select option')].find(element => normalize(element.value) === this.resultSize);
      if (!control || !control.dataset.variantId) return null;
      const available = !control.classList.contains('Unavailable') && !control.closest('li')?.classList.contains('Unavailable');
      return {control, available, id:control.dataset.variantId};
    }
    updateAvailability() {
      const choice = this.choice();
      const available = Boolean(choice?.available);
      this.selectButton.hidden = !available;
      this.selectButton.disabled = false;
      this.selectButton.textContent = this.t('select', this.resultSize);
      this.find('[data-contact]').hidden = available;
      this.find('[data-stock]').textContent = this.t(!choice ? 'missing' : available ? 'available' : 'sold_out', this.resultSize);
    }
    async selectSize() {
      if (!this.allowedFit()) return;
      const choice = this.choice();
      if (!choice?.available || this.pendingId) return this.updateAvailability();
      this.selectButton.disabled = true;
      this.find('[data-stock]').textContent = this.t('checking');
      try {
        const url = new URL(this.container.dataset.productUrl, location.origin);
        url.searchParams.set('variant', choice.id);
        url.searchParams.set('section_id', this.container.dataset.sectionId);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, {signal:AbortSignal.timeout(10000), credentials:'same-origin', cache:'no-store'});
        if (!response.ok) throw new Error('availability');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const variant = JSON.parse(html.querySelector('[data-product-json]').textContent).product.selected_or_first_available_variant;
        const selected = [...this.container.querySelectorAll('.Product__Block--variantPicker .ProductForm__Option')].map(option => (option.querySelector('input:checked') || option.querySelector('select'))?.value);
        const consistent = variant && String(variant.id) === choice.id && variant.options.every((value, index) => index === Number(this.dataset.sizeIndex) ? normalize(value) === this.resultSize : value === selected[index]);
        if (!consistent || !variant.available) {
          this.selectButton.hidden = true;
          this.find('[data-contact]').hidden = false;
          this.find('[data-stock]').textContent = this.t('sold_out', this.resultSize);
          return;
        }
        const currentId = this.container.querySelector('.Product__Block--variantPicker input[name="id"]')?.value;
        if (currentId === choice.id) {
          this.querySelector('[data-announcement]').textContent = this.t('selected', this.resultSize);
          this.dialog.close();
          return;
        }
        const fresh = this.choice();
        if (!fresh || fresh.id !== choice.id) throw new Error('selection changed');
        this.pendingId = choice.id;
        this.pendingTimer = setTimeout(() => {
          this.pendingId = null;
          this.selectButton.disabled = false;
          this.find('[data-stock]').textContent = this.t('retry');
        }, 12000);
        if (fresh.control.tagName === 'OPTION') {
          const select = fresh.control.closest('select');
          select.value = fresh.control.value;
          select.dispatchEvent(new Event('change', {bubbles:true}));
        } else fresh.control.click();
      } catch {
        this.find('[data-stock]').textContent = this.t('retry');
      } finally {
        if (!this.pendingId) this.selectButton.disabled = false;
      }
    }
  }
  if (!customElements.get('lasgym-size-assistant')) customElements.define('lasgym-size-assistant', LasgymSizeAssistant);
})();
  } catch(e) { console.error(e); }
})();

})();
